import { useEffect, useState } from 'react';
import { authFetch } from '../auth';

export default function AuthedImage({ src, alt, style }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;
    setUrl(null);
    authFetch(src)
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error('failed'))))
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!url) return <div style={style} />;
  return <img src={url} alt={alt} style={style} />;
}
